import React from 'react';
import { Button } from 'primereact/button';
import styles from './NavigationControls.module.css';

interface NavigationControlsProps {
  currentIndex: number;
  totalFindings: number;
  onNavigate: (index: number) => void;
}

export const NavigationControls = ({
  currentIndex,
  totalFindings,
  onNavigate
}: NavigationControlsProps) => {
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < totalFindings - 1;

  return (
    <div className={styles.controls}>
      <Button
        icon="pi pi-angle-left"
        label="Previous"
        onClick={() => onNavigate(currentIndex - 1)}
        disabled={!hasPrevious}
        className={styles.navButton}
        outlined
      />

      <div className={styles.indicator}>
        <span className={styles.currentNumber}>{currentIndex + 1}</span>
        <span className={styles.separator}>/</span>
        <span className={styles.totalNumber}>{totalFindings}</span>
      </div>

      <Button
        icon="pi pi-angle-right"
        iconPos="right"
        label="Next"
        onClick={() => onNavigate(currentIndex + 1)}
        disabled={!hasNext}
        className={styles.navButton}
        outlined
      />
    </div>
  );
};
